import Box from "ds/components/Box";
import Callout from "ds/components/Callout";
import TriggerButton from "views/Stack/Runs/components/TriggerButton";
import { Stack } from "types/generated";

type ExpiredInfoProps = {
  stack: Stack;
};

const ExpiredInfo = ({ stack }: ExpiredInfoProps) => {
  return (
    <Callout variant="warning">
      <Box direction="column" gap="small" align="start">
        This run has expired. Please trigger a new one.
        <TriggerButton stack={stack} variant="contrast" size="small" text="Trigger new run" />
      </Box>
    </Callout>
  );
};

export default ExpiredInfo;
